var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('strong',[_vm._v("SPANK SPANK: Insight import summary not implemented for "+_vm._s(_vm.insight.content_type)+"!!!!!")])])}
var staticRenderFns = []

export { render, staticRenderFns }